import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { klarysUrl } from './klarysApi';

const COULEURS = { executee: 'text-emerald-700', echec: 'text-rose-700', annulee: 'text-slate-500', en_attente: 'text-amber-700', en_cours: 'text-sky-700' };

export const KlarysJournal = ({ headers }) => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    axios.get(klarysUrl('/journal'), { headers }).then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!items) return <div className="p-6 text-center"><Loader2 className="h-5 w-5 animate-spin inline text-slate-400" /></div>;
  if (!items.length) return <p className="p-6 text-sm text-slate-500" data-testid="klarys-journal-empty">Aucune action de modification pour l'instant.</p>;
  return (
    <ul className="divide-y divide-slate-100 overflow-y-auto p-3" data-testid="klarys-journal">
      {items.map((a) => (
        <li key={a.id} className="py-2 text-xs" data-testid={`klarys-journal-${a.id}`}>
          <div className="flex gap-2">
            <span className="text-slate-500">{new Date(a.created_at).toLocaleString('fr-FR')}</span>
            <span className={`ml-auto font-semibold ${COULEURS[a.statut] || ''}`}>{a.statut}{a.resultat_statut ? ` · ${a.resultat_statut}` : ''}</span>
          </div>
          <p className="text-slate-800 mt-0.5">{a.resume}</p>
          <p className="font-mono text-[10px] text-slate-400">{a.methode} {a.chemin} — {a.confirme_par || a.par}</p>
        </li>
      ))}
    </ul>
  );
};
